export const PATHNAME = {
  LOGIN: "/login",
  SEACH_ORDER: "/search/order",
  SEACH_ITEM: "/search/item",
  SUM_ORDER: "/order/sum",
  SUM_ORDER_EXPRESS: "/order/express/sum",
  MANAGE_ORDER: "/order/manage",
  PRINT_BATCH: "/order/print/batch",
  PICK_FOCUS: "/focus/pick",
  PACK_FOCUS: "/focus/pack",
  CHECKOUTORDER_FOCUS: "/checkout/order/focus",
  RESERVE_STOCK: "/reserve/stock",
  REPORT_ORDER: "/report/order",
  HYDRO_CHAT: "/hydro/order",
  ORDER_SO: "/order/so",
  RECHECK_ORDER: "/recheck/order",
  USER_MANAGED: "/user/managed",
  USER_ALL: "/user/all",
  EDITSKUADD: "/editsku/add",
  EDITONEORDERTABLE: "/editsku/editoneorder-table",
  EDITONEORDERMULTI: "/editsku/editoneorder-multi",
  DASHBOARD: "/dashboard/dashboard-order",
  DASHBOARDECOM: "/dashboard/dashboard-order-batch",
  EDITWAITING: "/managestatus/editwaiting",
  EDITHOLDER: "/managestatus/editholder",
  RETURNORDERFOCUS: "/checkout/returnorderfocus",
  UPLOADTRACKING: "/checkout/uploadtracking",
  CUTTING_PAGE: "/cutting",
  CODE_G_PAGE: "/code-g",
  ORDER_HISTORY: "/history/order",
  SUPERVISORDASHBOARD: "/dashboard/supervisor",
  BATCH_SCHEDULE: "/batch/schedule",
  SHIPPING_MANAGE: "/shipping/manage",
};
